// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.MappingErrorPopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import MappingErrorTree from './Izenda.MappingErrorTree';
import connect from 'share/enhancers/Izenda.Connect';

@connect()
export default class MappingErrorPopup extends Component {
  static propTypes = {
    errorMessages: PropTypes.array
  };

  renderPopupBody() {
    const { localization, errorMessages } = this.props;
    return (
      <div>
        <div className="u_paddingRight u_paddingBottom">
          <div>{localization.getText('IMPORT_MAPPING_ERROR_INCONSISTENT_DATA')}</div>
          <div className="u_marginTop">{localization.getText('IMPORT_MAPPING_ERROR_GUIDES')}</div>
        </div>
          <MappingErrorTree errorMessages={errorMessages} />
      </div>
    );
  }

  renderPopupFooter() {
    const { localization } = this.props;
    return (
      <Popup.ConfirmationButton key="accept" type="accept">
        {localization.getText('COMMON_LABEL_OK')}
      </Popup.ConfirmationButton>
    );
  }

  render() {
    const { localization } = this.props;
    return (
      <Popup visible onClosing={this.props.onReject} type="none" autoClose={false} sizeClass="modal-lg">
        <Popup.Header title={localization.getText('IMPORT_MAPPING_ERROR_POPUP_TITLE')} />
        <Popup.Body>{this.renderPopupBody()}</Popup.Body>
        <Popup.Footer>{this.renderPopupFooter()}</Popup.Footer>
      </Popup>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/Popup/Izenda.MappingErrorPopup.js